module.exports = __webpack_public_path__ + "img/icon_design.34fa4a1.svg";